<template>
    <section class="background-section">
      <!-- Imagen superior tocando el borde superior -->
      <img src="../assets/total/Texto 2_2.png" alt="Logo Superior" class="top-image">
      
      <!-- Nueva imagen debajo de la superior -->
      <img src="../assets/total/Texto 3.png" alt="Imagen Adicional" class="below-top-image">
  
      <!-- Imagen central (ya existente) -->
      <img src="../assets/total/Cremas.png" alt="Crema Dental Colgate Periogard" class="center-image">
    </section>
  </template>
  
  <script setup>
  </script>
  
  <style scoped>
  .background-section {
    width: 100%;
    height: 130vh; /* Aumentamos la altura */
    background: url('../assets/total/Fondo.png') no-repeat center center;
    background-size: cover; /* Ajusta la imagen de fondo */
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    flex-direction: column;
  }
  
  .top-image {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 30%;  /* Tamaño reducido */
    height: auto;
  }
  
  .below-top-image {
    position: absolute;
    top: 18%;  /* Espacio debajo de la imagen superior */
    left: 50%;
    transform: translateX(-50%);
    width: 50%; /* Puedes ajustar este tamaño */
    height: auto;
  }
  
  /* @keyframes respirar {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.08); 
    }
    100% {
      transform: scale(1);
    }
  } */
  
  .center-image {
    max-width: 80%;
    max-height: 60%;
    object-fit: contain;
    margin-top: 100px; /* Espacio entre la imagen central y la superior */
    /* animation: respirar 6s ease-in-out infinite; */
  }
  </style>
  